// extracted by mini-css-extract-plugin
export var progressBar = "_nz-0";
export var progressBarInner = "_nz-1";